import AccessTime from '@mui/icons-material/AccessTime';
import AccountBalance from '@mui/icons-material/AccountBalance';
import AccountBalanceWallet from '@mui/icons-material/AccountBalanceWallet';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Add from '@mui/icons-material/Add';
import ArrowBackIosNew from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIos from '@mui/icons-material/ArrowForwardIos';
import Article from '@mui/icons-material/Article';
import AttachMoney from '@mui/icons-material/AttachMoney';
import Attractions from '@mui/icons-material/Attractions';
import Build from '@mui/icons-material/Build';
import Cached from '@mui/icons-material/Cached';
import Calculate from '@mui/icons-material/Calculate';
import CalendarMonth from '@mui/icons-material/CalendarMonth';
import Check from '@mui/icons-material/Check';
import ChildCare from '@mui/icons-material/ChildCare';
import Close from '@mui/icons-material/Close';
import ContentCopy from '@mui/icons-material/ContentCopy';
import Delete from '@mui/icons-material/Delete';
import DirectionsCar from '@mui/icons-material/DirectionsCar';
import Edit from '@mui/icons-material/Edit';
import Email from '@mui/icons-material/Email';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import FileCopy from '@mui/icons-material/FileCopy';
import Help from '@mui/icons-material/Help';
import Home from '@mui/icons-material/Home';
import ListAlt from '@mui/icons-material/ListAlt';
import LocationOn from '@mui/icons-material/LocationOn';
import LockOutlined from '@mui/icons-material/LockOutlined';
import Menu from '@mui/icons-material/Menu';
import MenuBook from '@mui/icons-material/MenuBook';
import Message from '@mui/icons-material/Message';
import MoreVert from '@mui/icons-material/MoreVert';
import NorthEastRounded from '@mui/icons-material/NorthEastRounded';
import Person from '@mui/icons-material/Person';
import Phone from '@mui/icons-material/Phone';
import PlayArrow from '@mui/icons-material/PlayArrow';
import Savings from '@mui/icons-material/Savings';
import Science from '@mui/icons-material/Science';
import Search from '@mui/icons-material/Search';
import SouthWestRounded from '@mui/icons-material/SouthWestRounded';
import SportsScore from '@mui/icons-material/SportsScore';
import Storefront from '@mui/icons-material/Storefront';
import SupportAgent from '@mui/icons-material/SupportAgent';
import ThumbDown from '@mui/icons-material/ThumbDown';
import ThumbUp from '@mui/icons-material/ThumbUp';
import TrendingDown from '@mui/icons-material/TrendingDown';
import TrendingUp from '@mui/icons-material/TrendingUp';
import UploadFile from '@mui/icons-material/UploadFile';
import WhatsApp from '@mui/icons-material/WhatsApp';

export const ProfileIcon = Person;
export const MenuIcon = Menu;
export const DebtsIcon = AccountBalanceWallet;
export const BudgetsIcon = Calculate;
export const CloseIcon = Close;
export const BlogIcon = MenuBook;
export const ChatIcon = Message;
export const SupportIcon = SupportAgent;
export const EmailIcon = Email;
export const WhatsAppIcon = WhatsApp;
export const BackIcon = ArrowBackIosNew;
export const ForwardIcon = ArrowForwardIos;
export const EditIcon = Edit;
export const InstitutionIcon = AccountBalance;
export const DeleteIcon = Delete;
export const AddIcon = Add;
export const ListIcon = ListAlt;
export const ClockIcon = AccessTime;
export const HomeIcon = Home;
export const ArticleIcon = Article;
export const EntertainmentIcon = Attractions;
export const ChildIcon = ChildCare;
export const GoalIcon = SportsScore;
export const IncomeIcon = TrendingUp;
export const ExpenseIcon = TrendingDown;
export const SavingsIcon = Savings;
export const ExpandMoreIcon = ExpandMore;
export const ExpandLessIcon = ExpandLess;
export const LikeIcon = ThumbUp;
export const HelpIcon = Help;
export const MoreIcon = MoreVert;
export const CheckIcon = Check;
export const ProfileCircleIcon = AccountCircle;
export const LockIcon = LockOutlined;
export const OutwardsIcon = NorthEastRounded;
export const InwardsIcon = SouthWestRounded;
export const RefreshIcon = Cached;
export const MoneyIcon = AttachMoney;
export const DislikeIcon = ThumbDown;
export const SearchIcon = Search;
export const CarIcon = DirectionsCar;
export const CalendarIcon = CalendarMonth;
export const StoreIcon = Storefront;
export const ServiceCenterIcon = Build;
export const LocationIcon = LocationOn;
export const PhoneIcon = Phone;
export const ScienceIcon = Science;
export const PlayArrowIcon = PlayArrow;
export const CopyIcon = ContentCopy;
export const FileCopyIcon = FileCopy;
export const UploadFileIcon = UploadFile;
